import { withRouter } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import { getEdgeEvents, getEdgeEventsFilter } from "../../actions/Users/authenticateEdgeEvents";
import { convertDateTimeIntoTimezone, getDecodeURI } from "../../utils/util";
import { useEffect, useRef, useState } from "react";
import { DEFAULT_PAGE_SIZE } from "../../constants/Constants";
import _ from "lodash";
import { RowPerPageHandler } from "../Pagination";
import { Button, Grid, InputAdornment, Paper, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from '@mui/icons-material/Close';
import TabButtons from "../../UserScreen/InventoryPage/InventorySettings/components/TabButtons/TabButtons";
import NetworkTable, { ColumnType } from "../../UserScreen/InventoryPage/InventorySettings/components/InterfacesTable/NetworkTable/NetworkTable";
import { CsvParameters, downloadAsCSV } from "../../actions/Users/authenticateCsvDownload";
import { MMDDYYYYHMMSS_DATE_FORMAT_24_HRS } from "../../utils/constants";
import DownloadCSV, { clearCsvDownload } from "../DownloadCSV";
import Download from '../../asset/image/DownloadUsage.svg';
import { CREATE_HA, UPDATE_DEVICE, SYNC_DEVICE } from "../../actions/types";

var Loader = require("react-loader");

const ManageHALogs = (props) => {
    const { newSummaryStartDate, newSummaryEndDate, getEdgeEvents, getEdgeEventsFilter, getEdgeEventsData, getEdgeEventsFilterData, selectedVessel, location, history, setSelectedTab, selectedTab, getEdgeEventsLoading, getEdgeEventsFilterLoading, downloadAsCSV, csvDataDownloded, csvDownloadId, userTimezone, updateDeviceData, syncDeviceData, createDeviceData, deleteHA} = props;

    const _q = getDecodeURI(location?.search);
    const DEFAULT_PAGE = 1;
    const dispatch = useDispatch();

    const [searchValue, setSearchValue] = useState<string>(_q.hasOwnProperty("search") && _q.search.trim() !== '' ? _q.search : "");
    const [page, setPage] = useState<number>(_q.hasOwnProperty("page") && '' != _q.page.trim() ? parseInt(_q.page) : DEFAULT_PAGE);
    const [limit, setLimit] = useState<number>(_q.hasOwnProperty("limit") && '' != _q.limit.trim() ? parseInt(_q.limit) : DEFAULT_PAGE_SIZE);
    const [totalCount, setTotalCount] = useState<number>(0);
    const [haLogsData, setHaLogsData] = useState<any[]>([]);
    const [filters, setFilters] = useState<any>({
        startTime: newSummaryStartDate,
        endTime: newSummaryEndDate,
        locationId: selectedVessel,
        pageSize: limit,
        offset: (page - 1) * limit,
        page: page,
        deviceIdFilter: "",
        moduleFilter: "",
        levelFilter: "",
        sourceFilter: "",
        searchValue: searchValue
    })
    const searchTimeoutRef = useRef<any>();
    const [columns, setColumns] = useState<any>([
        {
            label: "Timestamp",
            key: "ts",
            type: ColumnType.text,
            maxWidth: "90px",
            formatDateAndTime: true
        },
        {
            label: "Device Id",
            key: "device_id",
            type: ColumnType.text,
            maxWidth: "100px",
        },
        {
            label: "Device Name",
            key: "deviceAlias",
            type: ColumnType.text,
            maxWidth: "100px",
        },
        {
            label: "Level",
            key: "level",
            type: ColumnType.text,
            maxWidth: "80px",
        },
        {
            label: "Description",
            key: "description",
            type: ColumnType.text,
            maxWidth: "200px",
        },
        {
            label: "Metadata",
            key: "metadata",
            type: ColumnType.metadata,
            maxWidth: "50px",
        },
    ])

    useEffect(() => {
        let _startDate = newSummaryStartDate;
        let _endDate = newSummaryEndDate;
        let _limit = _q.hasOwnProperty("limit") ? _q.limit : filters.pageSize;
        let _page = _q.hasOwnProperty("page") ? _q.page : filters.page;
        let _searchValue = _q.hasOwnProperty("searchValue") ? _q.searchValue : filters.searchValue;

        let parameters = {
            startTime: _startDate,
            endTime: _endDate,
            locationId: selectedVessel,
            pageSize: _limit,
            offset: (_page - 1) * _limit,
            page: _page,
            deviceIdFilter: "",
            moduleFilter: "",
            levelFilter: "",
            search: "",
            sourceFilter: "",
            searchValue: _searchValue
        }

        parameters.moduleFilter = 'and module IN (\'HA\')';
        if (_searchValue) {
            parameters.search = `and (concat_ws(',',if(device_id IS NULL,'',device_id),if(deviceAlias IS NULL,'',deviceAlias),if(level IS NULL,'',level),if(deviceAlias IS NULL,'',deviceAlias),
          if(description IS NULL,'',description),if(source IS NULL,'',source)) ILIKE '%${_searchValue}%' OR  b_metadata ILIKE '%${_searchValue}%')`
        }
        getEdgeEventsFilter(parameters);
        getEdgeEvents(parameters);
    }, [selectedVessel, newSummaryStartDate, newSummaryEndDate, filters])

    useEffect(() => {
        let _startDate = newSummaryStartDate;
        let _endDate = newSummaryEndDate;
        let _limit = _q.hasOwnProperty("limit") ? _q.limit : filters.pageSize;
        let _page = _q.hasOwnProperty("page") ? _q.page : filters.page;
        let _searchValue = _q.hasOwnProperty("searchValue") ? _q.searchValue : filters.searchValue;

        let parameters = {
            startTime: _startDate,
            endTime: _endDate,
            locationId: selectedVessel,
            pageSize: _limit,
            offset: (_page - 1) * _limit,
            page: _page,
            deviceIdFilter: "",
            moduleFilter: "",
            levelFilter: "",
            search: "",
            sourceFilter: "",
            searchValue: _searchValue
        }

        parameters.moduleFilter = 'and module IN (\'HA\')';
        if (_searchValue) {
            parameters.search = `and (concat_ws(',',if(device_id IS NULL,'',device_id),if(deviceAlias IS NULL,'',deviceAlias),if(level IS NULL,'',level),if(deviceAlias IS NULL,'',deviceAlias),
          if(description IS NULL,'',description),if(source IS NULL,'',source)) ILIKE '%${_searchValue}%' OR  b_metadata ILIKE '%${_searchValue}%')`
        }
        if(!_.isEmpty(updateDeviceData) || !_.isEmpty(createDeviceData) || !_.isEmpty(syncDeviceData) || !_.isEmpty(deleteHA)){
            getEdgeEventsFilter(parameters);
            getEdgeEvents(parameters);
        }
    },[updateDeviceData, syncDeviceData, createDeviceData, deleteHA]) 

    useEffect(() => {
        if (!_.isEmpty(getEdgeEventsData)) {
            const edgeEvents = getEdgeEventsData;
            if (edgeEvents) {
                const rows: any[] = edgeEvents?.data?.rows;
                const columns: string[] = edgeEvents?.data?.columns;
                const haLogsData: any[] = [];
                for (let i = 0; i < rows?.length; i++) {
                    const row = {};
                    const currentRow = rows[i];
                    columns.forEach((column, index) => {
                        row[column] = currentRow[index];
                    })
                    haLogsData.push(row);
                }
                setHaLogsData(haLogsData);
            }
        }
    }, [getEdgeEventsData]);

    useEffect(() => {
        if (!_.isEmpty(getEdgeEventsFilterData)) {
            const edgeEvents = getEdgeEventsFilterData?.data;
            if (edgeEvents && edgeEvents.hasOwnProperty('filters')) {
                const data = edgeEvents.filters.data;
                if (data.length >= 3) {
                    const totalRecords = Number.parseInt(data[4]);
                    let totalPages = Math.ceil(totalRecords / limit);
                    let fromIndex = (totalRecords > 0) ? (page * limit + 1) : 0;
                    let toIndex = (fromIndex + limit - 1) > totalRecords ? totalRecords : (fromIndex + limit - 1);
                    setTotalCount(totalRecords);
                } else {
                    setTotalCount(0);
                }
            }
        }
    }, [getEdgeEventsFilterData])

    const handlePageChange = (newPage, limit) => {
        setPage(newPage);
        setLimit(limit);
        setFilters({ ...filters, page: newPage, offset: (newPage - 1) * limit });
        getEdgeEvents({ ...filters, page: newPage, offset: (newPage - 1) * limit });
    };

    const handleChangeRowsPerPage: RowPerPageHandler = (limit) => {
        if (Number(limit)) {
            setPage(DEFAULT_PAGE)
            setLimit(Number(limit));
            setFilters({ ...filters, page: DEFAULT_PAGE, pageSize: limit, offset: (DEFAULT_PAGE - 1) * Number(limit) });
            getEdgeEvents({ ...filters, page: DEFAULT_PAGE, pageSize: limit, offset: (DEFAULT_PAGE - 1) * Number(limit) });
        }
    };

    const handleSearch = (value: string) => {
        setFilters({
            ...filters,
            searchValue: value,
            page: 1
        });
    };

    const handleOnSearchClick = () => {
        handleSearch(searchValue);
    }

    const handleOnSearchChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
        setSearchValue(e.target.value);
        if (searchTimeoutRef.current) {
            clearTimeout(searchTimeoutRef.current);
        }
        searchTimeoutRef.current = setTimeout(() => {
            searchTimeoutRef.current = undefined;
            handleSearch(e.target.value);
        }, 1000)
    }

    const handleOnSearchClear = () => {
        setSearchValue('');
        handleSearch('');
    }

    const handleDownloadReport = () => {
        const params: CsvParameters = {
            type: "QUERY_CH",
            id: "manage-config-HA-log-status",
            payload: {
                startTime: newSummaryStartDate,
                endTime: newSummaryEndDate,
                locationId: selectedVessel,
                pageSize: totalCount,
                offset: 0,
                page: 1,
                deviceIdFilter: "",
                moduleFilter: "",
                levelFilter: "",
                sourceFilter: "",
                search: "",
                searchValue: searchValue ? `and (concat_ws(',',if(device_id IS NULL,'',device_id),if(deviceAlias IS NULL,'',deviceAlias),if(level IS NULL,'',level),if(deviceAlias IS NULL,'',deviceAlias),
                   if(description IS NULL,'',description),if(source IS NULL,'',source)) ILIKE '%${searchValue}%' OR  b_metadata ILIKE '%${searchValue}%')` : ''
            },
            queryName: "EDGE_EVENTS",
        };
        downloadAsCSV(params);
    }

    useEffect(() => {
        if (csvDataDownloded && csvDataDownloded.length > 0) {
            if (csvDownloadId === "manage-config-HA-log-status") {
                DownloadCSV(convertToCsv(csvDataDownloded, userTimezone),
                    {
                        formatters: {
                            0: 'ESC-COMMA',
                            2: 'ESC-COMMA',
                            4: 'ESC-COMMA',
                            5: 'ESC-COMMA',
                        }
                    }
                )
            }
            return () => {
                dispatch(clearCsvDownload());
            }
        }
    }, [csvDataDownloded]);

    const convertToCsv = (data: any[][], userTimezone: string) => {
        const [_columns, ...rows] = data;
        const csvRows: any[] = [];
        rows.forEach(row => {
            const timestamp = convertDateTimeIntoTimezone(row[0], userTimezone, MMDDYYYYHMMSS_DATE_FORMAT_24_HRS);
            const metadata = JSON.stringify(JSON.parse(row[7]?.trim() || '{}')).replace(/"/g, '""').replace(/,/g, ';');
            csvRows.push([timestamp, row[2], row[8], row[3], row[5], metadata]);
        })
        return [['Timestamp', 'Device Id', 'Device Name', 'Level', 'Description', 'Metadata'], ...csvRows];
    }

    return (
        <Paper elevation={0} className="quota_management--dashboard manage-config-log-head">
            <div className="manageConfiglogHeadName" >Logs</div>
            <Grid classes={{ root: "quota_management--base--flew quota_management--base--flex--justify--end quota_management--base--padding_05x" }}>
                <Grid item xs={12} sm={12} md={12} lg={12} className='logs-table-search-container topbarWidth alignTopbarItemsCenter'>
                    <Grid item xs={4} sm={4} md={4} lg={4} className="searchbarBox searchbarMaxWidth1">
                        <TextField
                            id="outlined-basic"
                            variant="outlined"
                            placeholder="Type something"
                            autoComplete="off"
                            value={searchValue}
                            onChange={handleOnSearchChange}
                            onKeyDown={(e) => { if (e.key === 'Enter') { handleOnSearchClick() } }}
                            size="small"
                            InputLabelProps={{ className: "serachLabel" }}
                            InputProps={{
                                className: "searchbarInputs",
                                startAdornment: (
                                    <InputAdornment position="start">
                                        {!searchValue && <SearchIcon
                                            className="searchbarIconsPosition"
                                            onClick={handleOnSearchClick}
                                        />}
                                        {searchValue && <CloseIcon
                                            className="searchbarIconsPosition"
                                            onClick={handleOnSearchClear}
                                        />
                                        }
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Grid>
                    <Grid item xs={2} sm={2} md={2} lg={2} ml={3}>
                        <TabButtons
                            options={['Device', 'HA']}
                            selected={selectedTab}
                            onChange={setSelectedTab}
                        />
                    </Grid>
                    <Grid item xs={6} sm={6} md={6} lg={6} className="dwn-margin-auto">
                        {totalCount > 0 && haLogsData && haLogsData?.length !== 0 && <Grid item xs={6} sm={6} md={6} lg={6}>
                            <div className="download-summary-btn marg-left-auto" onClick={handleDownloadReport}><img className="downloadImg" src={Download} alt="" /><Button>Download</Button> </div>
                        </Grid>}
                        {getEdgeEventsLoading || getEdgeEventsFilterLoading ? (
                            <div className="config-logs-loader">
                                <Loader radius={4} length={5} lines={10} width={2} color={"#264C86"} />
                            </div>
                        ) : null}
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} className="TopUsersContainer">
                <NetworkTable
                    data={haLogsData}
                    columns={columns}
                    enablePagination={true}
                    rowsPerPageOptions={[10, 15, 25, 50, 100]}
                    defaultRowsPerPage={15}
                    headingHeight={40}
                    maxHeight={`calc(100vh - 450px)`}
                    totalRowCount={totalCount}
                    onPageChange={handlePageChange}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    page={page}
                    rowsPerPage={limit}
                />
            </Grid>
        </Paper>
    );
}

const mapStateToProps = (state) => ({
    authReducer: state.authReducer,
    errorReducer: state.errorReducer,
    newSummaryStartDate: state?.authReducer?.newSummaryStartDate,
    newSummaryEndDate: state?.authReducer?.newSummaryEndDate,
    getEdgeEventsData: state?.authReducer?.getEdgeEvents,
    getEdgeEventsFilterData: state?.authReducer?.getEdgeEventsFilter,
    getEdgeEventsLoading: state?.authReducer?.getEdgeEventsLoading,
    getEdgeEventsFilterLoading: state?.authReducer?.getEdgeEventsFilterLoading,
    csvDataDownloded: state?.authReducer?.csvDataDownloded,
    csvDownloadId: state?.authReducer?.csvDownloadId,
    userTimezone: state?.authReducer?.userTimezone,
    updateDeviceData: state.authReducer?.updateDevice,
    syncDeviceData: state.authReducer?.syncDevice,
    createDeviceData: state.authReducer?.createHighAvailability,
    deleteHA: state.authReducer?.deleteHighAvailability
});
export default withRouter(
    connect(mapStateToProps, {
        getEdgeEvents,
        getEdgeEventsFilter,
        downloadAsCSV
    })(ManageHALogs)
);